import { render } from "./CountryCard.vue?vue&type=template&id=1cdf0344&scoped=true"
import script from "./CountryCard.vue?vue&type=script&lang=js"
export * from "./CountryCard.vue?vue&type=script&lang=js"

import "./CountryCard.vue?vue&type=style&index=0&id=1cdf0344&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdf0344"]])

export default __exports__